<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;
      Manage Assignments</h5>
  </div>
<div id="mainContent" class="container">
  <div class="row pt-3">
    <div class="col-md-10 offset-md-1" style="">
      <button id="addAssignmentBtn" name="addAssignmentBtn" mat-raised-button class="btn-theme" style="float:right" matTooltip="Click to add assignment" matTooltipPosition="left"
      (click)="openModal(modalContent,'add')">
          <i class="fa fa-plus-square" aria-hidden="true"></i>&nbsp;&nbsp; Assignment
      </button>
    </div>
  </div>
<div class="pb-2 pt-2">
  <div class="col-md-12" >
    <table class="table table-bordered table-striped table-sm">
      <thead class="">
        <tr>
          <th scope="col">Sr.No.</th>
          <th scope="col">Name</th>
          <th scope="col">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let assignment of assignmentList; index as i" id="assignment_{{i+1}}">
          <td scope="row">{{i+1}}</td>
          <td>{{assignment.name}}</td>
          <td>
            <button id="editAssignmentBtn_{{i+1}}" name="editAssignmentBtn_{{i+1}}" class="btn btn-sm btn-outline-theme"  (click)="onEditClick(modalContent,assignment)"
            matTooltip="Click to edit" matTooltipPosition="above">
              <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
            </button> &nbsp;&nbsp;
            <button id="deleteAssignmentBtn_{{i+1}}" name="deleteAssignmentBtn_{{i+1}}" class="btn btn-sm btn-outline-danger" (click)="onDeleteClick(assignment)"
            matTooltip="Click to delete" matTooltipPosition="above">
              <i class="fa fa-trash-o" aria-hidden="true"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
</div>
</div>

<!-- Modal Template -->
<ng-template #modalContent let-modal>
  <div class="modal-header bg-theme bg-theme-txt pt-2 pb-2">
    <h5 class="modal-title" id="modal-basic-title">Assignment</h5>
    <!-- <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button> -->
  </div>
  <div class="modal-body">
    <form [formGroup]="modalForm">

      <div class="row">
        <label for="approversName" class="col-sm-4">Assignment Name :</label>
        <div class="col-sm-8">
        <input id="name" name="name" type="text" class="form-control form-control-xs"
         formControlName="name" [class.is-invalid]="formErrors.name && formSubmitted">
        </div>
        </div>
    </form>
  </div>
  <div class="modal-footer" style="">
    <div class="row col-md-12">
        <div class="col-sm-6"></div>
        <div class="col-sm-3">
            <button id="saveAssignmentBtn" name="saveAssignmentBtn" type="button" *ngIf="modalStatus=='add'" class="btn btn-sm btn-block btn-outline-theme" (click)="onSaveClick()">Save</button>
            <button id="updateAssignmentBtn" name="updateAssignmentBtn" type="button" *ngIf="modalStatus=='edit'" class="btn btn-sm btn-block btn-outline-theme" (click)="onUpdateClick()">Update</button>
        </div>
        <div class="col-sm-3">
          <button id="closeAssignmentBtn" name="closeAssignmentBtn" type="button"  class="btn btn-sm btn-block btn-outline-secondary" (click)="modal.dismiss('Cross click')">Close</button>
      </div>
    </div>
</div>
</ng-template>
